import React, { useEffect, useState, useRef } from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const images = [
  
  '/819360342.jpg',
  '/0EEEAAA0-5C26-4738-B982-12C42C6A77ED.jpeg',
  '/domatio.png',
  '/domatio2.png',
  '/2αβγ.jpg',
  '/2α.jpg',
  '/back.avif',
  '/F1989693-8DCB-4017-A1D6-2405ABF3AA0C_1_102_o.jpeg',
];

const Hero = ({ getAirbnbUrl, getBookingUrl, getYourRentalsUrl, openInNewTab }) => {
  const [current, setCurrent] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useLanguage();

  const getUrlFor = (id) => {
    if (id === 'airbnb' && getAirbnbUrl) return getAirbnbUrl();
    if (id === 'booking' && getBookingUrl) return getBookingUrl();
    if (id === 'yourRentals' && getYourRentalsUrl) return getYourRentalsUrl();
    return '#';
  };

  const bookingLinks = [
    {
      id: 'phone',
      name: t('hero.phone'),
      url: 'tel:+306983446269',
      logo: <FaPhoneAlt className="text-cyan-600 text-2xl" />,
      isPhone: true,
    },
    {
      id: 'airbnb',
      name: t('hero.airbnb'),
      logo: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M16.001 4.667c-2.2 0-4.267 1.2-5.4 3.134L4.534 20.267c-1.067 1.867-1.067 4.2 0 6.067 1.067 1.867 3.067 3.066 5.267 3.066h12.398c2.2 0 4.2-1.199 5.267-3.066 1.067-1.867 1.067-4.2 0-6.067L21.4 7.801C20.267 5.867 18.2 4.667 16.001 4.667zm0 2c1.467 0 2.8.8 3.533 2.067l6.067 10.666c.733 1.267.733 2.867 0 4.134-.733 1.267-2.067 2.066-3.533 2.066H9.933c-1.466 0-2.8-.799-3.533-2.066-.733-1.267-.733-2.867 0-4.134l6.067-10.666C13.2 7.467 14.534 6.667 16.001 6.667zm0 4.666a2.667 2.667 0 100 5.334 2.667 2.667 0 000-5.334z" fill="#FF5A5F"/></svg>
      ),
    },
    {
      id: 'booking',
      name: t('hero.booking'),
      logo: (
        <svg width="32" height="32" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#003580"/><text x="50%" y="60%" textAnchor="middle" fontSize="28" fill="#fff" fontFamily="Arial,Helvetica,sans-serif" fontWeight="bold">B</text></svg>
      ),
    },
    {
      id: 'yourRentals',
      name: t('hero.yourRentals'),
      logo: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="8" fill="#00B4A0"/><text x="50%" y="60%" textAnchor="middle" fontSize="16" fill="#fff" fontFamily="Arial,Helvetica,sans-serif" fontWeight="bold">YR</text></svg>
      ),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <section className="h-screen min-h-[500px] w-full relative overflow-hidden flex items-center justify-center">
      {/* Carousel Images */}
      {images.map((img, idx) => (
        <img
          key={img}
          src={img}
          alt="Azure Loft Slide"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 z-0 ${current === idx ? 'opacity-100' : 'opacity-0'}`}
          style={{ objectPosition: 'center' }}
        />
      ))}
      {/* Overlay (για καλύτερη αναγνωσιμότητα του μενού/κειμένου) */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/60 via-cyan-700/30 to-blue-400/20 z-10" />
      {/* Content πάνω από το carousel */}
      <div className="relative z-20 flex flex-col items-center justify-center h-full w-full text-center max-w-[1200px] mx-auto px-2 sm:px-4">
        <h1 className="text-3xl sm:text-5xl md:text-7xl font-black mb-4 tracking-tight text-white drop-shadow-lg font-[400]" style={{ fontFamily: 'Dancing Script, Montserrat, Poppins, sans-serif', fontWeight: 400, letterSpacing: '0.08em' }}>{t('hero.title')}</h1>
        <div className="relative flex flex-col items-center gap-4 mt-6">
          <div className="relative" ref={dropdownRef}>
            <button
              className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-6 py-4 sm:px-10 sm:py-6 md:px-14 md:py-7 font-bold rounded-full shadow-xl hover:scale-105 hover:from-cyan-500 hover:to-blue-500 transition-all duration-200 text-2xl sm:text-3xl md:text-4xl flex items-center gap-2 sm:gap-4"
              onClick={() => setDropdownOpen((open) => !open)}
              aria-haspopup="listbox"
              aria-expanded={dropdownOpen}
            >
              {t('hero.bookNow')}
              <svg className={`ml-2 transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`} width="24" height="24" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>
            </button>
            {dropdownOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-64 sm:w-80 bg-white rounded-xl shadow-2xl border border-blue-100 z-50 py-2 animate-fade-in">
                {bookingLinks.map((platform) => (
                  <a
                    key={platform.id}
                    href={platform.isPhone ? platform.url : getUrlFor(platform.id)}
                    target={platform.isPhone ? undefined : '_blank'}
                    rel={platform.isPhone ? undefined : 'noopener noreferrer'}
                    className="flex items-center gap-3 sm:gap-4 px-4 sm:px-6 py-4 sm:py-5 hover:bg-blue-50 transition text-lg sm:text-2xl font-semibold text-gray-800 rounded-xl"
                    onClick={(e) => {
                      if (!platform.isPhone && openInNewTab) {
                        e.preventDefault();
                        openInNewTab(getUrlFor(platform.id));
                      }
                      setDropdownOpen(false);
                    }}
                  >
                    {platform.logo}
                    <span>{platform.name}</span>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;